export default __webpack_public_path__ + "static/media/shop-not-found.55420810.svg";